import React, { useMemo } from 'react';

import useEvent from '@lyearn/core/hooks/useEvent';
import useScreen from '@lyearn/core/hooks/useScreen';
import { PopoverContentPosition } from '@lyearn/ui';
import { Popover } from '@lyearn/ui';
import { TaskStatusEntityConfig } from '@/components/FilterManager/EntityFilter/entity/task-status';
import { getTaskStatusFilterOption } from '@/components/FilterManager/EntityFilter/entity/task-status/utils';
import FilterBody from '@/components/FilterNew/components/Body';
import { FilterBodyProps } from '@/components/FilterNew/components/Body/types';
import { NewFilterOption } from '@/components/FilterNew/types';
import { StatusFragment } from '@/modules/tasks/views/TaskStasusesManager/graphql/fragments/generated/Status';

const LIST_CONFIG: FilterBodyProps['listConfig'] = {
  ...TaskStatusEntityConfig,
  listVariant: 'single-ungrouped-infinite',
};

function StatusMenu({
  actionItemId,
  children,
  open,
  statusInfo,
  popoverPosition,
  onOpenChange,
  onStatusChange,
}: {
  actionItemId?: string;
  children: React.ReactNode;
  open: boolean;
  statusInfo?: StatusFragment | null;
  popoverPosition?: PopoverContentPosition;
  onOpenChange: (open: boolean) => void;
  onStatusChange: (
    statusInfo: StatusFragment,
    id?: string,
  ) => Promise<string | boolean | null | undefined> | void;
}) {
  const onChange = useEvent((value: NewFilterOption<{}, StatusFragment>[]) => {
    onStatusChange(value?.[0]?.item!, actionItemId);
  });
  const { isMobile } = useScreen();

  const initialSelectedOptions = useMemo(
    () => (statusInfo ? [getTaskStatusFilterOption(statusInfo)] : []),
    [statusInfo],
  );

  return (
    <Popover open={open} onOpenChange={onOpenChange}>
      {({ open }) => (
        <>
          <Popover.Button>{children}</Popover.Button>
          {open ? (
            <Popover.Content
              position={popoverPosition}
              renderAs={isMobile ? 'bottom-sheet' : 'popover'}>
              <FilterBody
                initialSelectedOptions={initialSelectedOptions}
                listConfig={LIST_CONFIG}
                onChange={onChange}
                onToggle={onOpenChange}
              />
            </Popover.Content>
          ) : null}
        </>
      )}
    </Popover>
  );
}

export default StatusMenu;
